import { Modal } from '@els/els-react--modal';
import useCourseSelectionModalHook from './useCourseSelectionModal';
import { renderCourseList } from './CourseSelectionModalHelpers';
var CourseSelectionModal = function (props) {
    var _a = useCourseSelectionModalHook(props), tempCourseId = _a.tempCourseId, radioChangeHandler = _a.radioChangeHandler, goButtonHandler = _a.goButtonHandler, title = _a.title, goButtonDescription = _a.goButtonDescription, _b = _a.selectOptions, selectOptions = _b === void 0 ? [] : _b;
    return (<Modal className="c-course-select-modal" label="Course Selection" onClose={function () { return props.onCloseModal(); }} focusTrapProps={{ returnFocusOnDeactivate: true }}>
      <div>
        <div className="c-els-field">
          <div className="c-course-select-modal__label">
            <h2 className="c-els-field__label-text">{title}</h2>
          </div>
          <span className="c-els-field__wrap c-els-field__wrap--icon-right">
            <span className="u-els-margin-top-2x c-els-field__label-text">Select Course:</span>
            <div className="o-els-container c-els-radio-modal">
              {renderCourseList({
            courseList: selectOptions,
            selectedCourseId: tempCourseId,
            onSelectCourse: radioChangeHandler
        })}
            </div>
            <button onClick={function () { return goButtonHandler(); }} className="u-els-width-1o1 u-els-margin-top-4x c-els-button c-els-button--default c-els-button--primary c-els-button--c-els-button c-els-button--primary" type="button">
              {goButtonDescription}
            </button>
          </span>
        </div>
      </div>
    </Modal>);
};
export default CourseSelectionModal;
